module.exports = __webpack_public_path__ + "static/media/envelope.da0e9459.svg";